import {LOGIN, USER, API} from '@/services/api'
import {request, METHOD, removeAuthorization} from '@/utils/request'
import download from './downloadFile'

/**
 * 1.1获取所有用户
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function getAllUsers(params) {
  return request(USER+"/getAllUsers", METHOD.GET, params)
}

/**
 * 1.2获取所有用户的数量
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function getAllUsersCount(params) {
  return request(USER+"/getAllUsersCount", METHOD.GET, params)
}

/**
 * 获取指定机构用户的数量
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function getUserCount(params) {
  return request(USER+"/getUserCount", METHOD.GET, params)
}

/**
 * 1.4根据组织机构类型获取到里面的人员
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function getUsersByTypeName(params) {
  return request(USER+"/getOrgUsersByName", METHOD.GET, params)
}

/**
 * 1.5 添加一个用户
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function addOneUser(params) {
  return request(USER+"/addOneUser", METHOD.POST, params)
}

/**
 * 1.7 编辑一个用户
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function editOneUser(params) {
  return request(USER+"/editOneUser", METHOD.POST, params)
}

/**
 * 删除指定的用户
 * @param {*} params 
 * @returns 
 */
export function delUser(params){
  return request(USER+"/removeOneUser", METHOD.DELETE, params)
}

/**
 * 更新指定用户状态
 * @param {*} params 
 * @returns 
 */
export function updateUserStatus(params){
  return request(USER+"/updateStatus", METHOD.POST, params)
}


/**
 * 根据角色、组织机构、学生姓名查询学生树

 * @param {*} params 
 * @returns 
 */
export function getOrgAndUserTree(params){
  return request(USER+"/getOrgAndUserTree", METHOD.GET, params)
}

/**
 * 根据角色、学生姓名查询学生分页数据
 * @param {*} params 
 * @returns 
 */
export function getUserByRoleId(params){
  return request(USER+"/getUserByRoleId", METHOD.GET, params)
}

/**
 * 导入用户
 * @param {*} params 
 * @returns 
 */
export function importUsers(params){
  return request(USER+"/importUsers", METHOD.POST, null, {params})
}

/**
 * 下载组织机构中导入用户模板
 */
export function downloadUserExcel(){
  // window.location.href = API+"/templeteConfig/downloadUserExcel"
  download(API+"/templeteConfig/downloadUserExcel",null, "组织结构导入模板.xlsx")
}


/**
 * 登录服务
 * @param name 账户名
 * @param password 账户密码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function login(name, password) {
  return request(LOGIN, METHOD.POST, {
    name: name,
    password: password
  })
}

/**
 * getUserInfo
 * @param {*} params 
 * @returns 
 */
export async function getUserInfo(params) {
  // return request(API+"/authentication/getToken", METHOD.GET, params)
  return request(API+"/authentication/ticketValidate", METHOD.GET, params)
}

export async function getRoutesConfig() {
  return [{
    router: 'root',
    // children: [
    //   {
    //     router: 'dashboard',
    //     children: [ 'analysis'],
    //   },
    //   {
    //     router: '离校管理',
    //     children: ['离校管理 ', '材料认领确认管理'],
    //   },
    //   {
    //     router: '客户端管理',
    //     children: ['轮播图', '通知公告']
    //   },
    //   {
    //     router: '离校设置',
    //     children: ['事项管理', '消息模板', '毕业名单', '材料认领管理', '材料认领管理明细', '毕业名单明细']
    //   },
    //   {
    //     router: '系统设置',
    //     children: ['组织机构', '权限管理', '数据字典']
    //   }
    // ]
  }] 
}

/**
 * 退出登录
 */
export function logout() {
  localStorage.removeItem(process.env.VUE_APP_ROUTES_KEY)
  localStorage.removeItem(process.env.VUE_APP_PERMISSIONS_KEY)
  localStorage.removeItem(process.env.VUE_APP_ROLES_KEY)
  setTimeout(() => {
    removeAuthorization()
  }, 200);
  window.location.href = process.env.VUE_APP_LOGOUT_URL
}
export default {
  login,
  logout,
  getRoutesConfig
}
